module.exports = __webpack_public_path__ + "img/chicken.3c3753c2.jpg";